import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';

class TableContent extends React.Component {

    _takeColumns = () => ([
        {
            title: '员工账号',
            dataIndex: 'loginName',
            key: 'loginName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '员工姓名',
            dataIndex: 'emplName',
            key: 'emplName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '所属部门',
            dataIndex: 'deptName',
            key: 'deptName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '职位',
            dataIndex: 'position',
            key: 'position',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '角色',
            dataIndex: 'roleNames',
            key: 'roleNames',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: '10%',
            render: (text, item) => this._renderActionCell(item)
        }
    ]);

    _compColumns = () => ([
        {
            title: '员工账号',
            dataIndex: 'loginName',
            key: 'loginName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '员工姓名',
            dataIndex: 'emplName',
            key: 'emplName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '运营公司',
            dataIndex: 'companyName',
            key: 'companyName',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderTextCell(text))
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: '10%',
            render: (text, item) => this._renderActionCell(item)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };

    _renderActionCell = (record) => {
        const { tableAction, emplTableType } = this.props;
        if (emplTableType == 1 || emplTableType == 2) {
            return (
                <div className={styles.action}>
                    <div className={styles.item} onClick={() => tableAction('edit', emplTableType, record)}>编辑</div>
                    <div className={styles.item} onClick={() => tableAction('del', emplTableType, record)}>移除</div>
                </div>
            );
        }
        else if (emplTableType == 3) {
            return (
                <div className={styles.action}>
                    <div className={styles.item} onClick={() => tableAction('edit', emplTableType, record)}>编辑</div>
                </div>
            );
        } else {
            return (
                <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                    -
                </div>
            );
        }
    }

    render() {
        const { paginationChange, emplTableType } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer} style={{ height: '100%' }}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={emplTableType == 4 ? this._compColumns() : this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: 800 }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    emplTableType: PropTypes.number, // // 该角色下的员工是否可编辑（系统默认的顶级角色不可编辑，新建的二级角色可以编辑）
};

export default TableContent;